import { render, staticRenderFns } from "./community_xiaozu.vue?vue&type=template&id=3375c3bc&scoped=true"
import script from "./community_xiaozu.vue?vue&type=script&lang=js"
export * from "./community_xiaozu.vue?vue&type=script&lang=js"
import style0 from "./community_xiaozu.vue?vue&type=style&index=0&id=3375c3bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3375c3bc",
  null
  
)

export default component.exports